import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi.js";
import * as mutationTypes from "../store/mutation-types";

const GroupOrderProvider = {
	async create({idpToken, tenantId, shopId, deliveryMethod}) {
		const res = await BifrostBackendNestApi.post("/group-orders", {tenantId, shopId, deliveryMethod}, {headers: {Authorizationidp: idpToken }});
		return res.data;
	},
	validateGroupOrderInvitation(groupOrderId, tenantId, store) {
		return BifrostBackendNestApi.get(`/group-orders/${groupOrderId}/validate?tenantId=${tenantId}`)
			.then((res) => {
				return res.data;
			}).catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	},
	sendProductSelections(groupOrderId, productSelections, userData, tenantId, store) {
		return BifrostBackendNestApi.put(`/group-orders/${groupOrderId}`, {
			productSelections,
			userData,
			tenantId
		})
			.then((res) => {
				return res.data;
			}).catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	},
	async removeFriendOrder(idpToken, groupOrderId, orderItemId, tenantId, store) {
		return BifrostBackendNestApi.put(`/group-orders/${groupOrderId}/remove-items/${orderItemId}`, {
			tenantId
		}, {
			headers: {Authorizationidp: idpToken }
		})
			.then( res => {
				return res.data;
			})
			.catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	},
	async getOne(idpToken, groupOrderId, tenantId, store) {
		return BifrostBackendNestApi.get(`/group-orders/${groupOrderId}?tenantId=${tenantId}`,
			{
				headers: {Authorizationidp: idpToken }
			})
			.then((res) => {
				return res.data;
			}).catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	},
	async updateOrderId(idpToken, groupOrderId, tenantId, orderId, store) {
		return BifrostBackendNestApi.patch(`group-orders/${groupOrderId}?tenantId=${tenantId}`, {tenantId, orderId},
			{
				headers: {Authorizationidp: idpToken}
			})
			.then(() => {
				return;
			}).catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	},
	async cancelGroupOrder(idpToken, groupOrderId, tenantId, store) {
		return BifrostBackendNestApi.delete(`group-orders/${groupOrderId}?tenantId=${tenantId}`,
			{
				headers: {Authorizationidp: idpToken}
			})
			.then(() => {
				return;
			}).catch((err) => {
				handleMessages(err.response.data.message, store);
			});
	}
};
const handleMessages = (message, store) => {
	switch (message) {
	case "order_not_found":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.groupOrder.orderNotFound"
		);
		break;
	case "order_finished":
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.groupOrder.orderFinished"
		);
		break;
	default:
		store.commit(
			mutationTypes.SET_GLOBAL_INFO_DIALOG,
			"shopComponents.gt2.shoppingCart.groupOrder.generalGroupOrderError"
		);
	}
};
export default Object.freeze(GroupOrderProvider);
